import React from "react";
import "./skills.css";

const SkillArea = () => {
  const Skills = [
    {
      STitle: "HTML&CSS",
      percentage: "95%",
      BgColor: "gray",
      lineColor: "blue",
    },
    {
      STitle: "Javascript",
      percentage: "70%",
      BgColor: "gray",
      lineColor: "red",
    },
    {
      STitle: "React.js",
      percentage: "75%",
      BgColor: "gray",
      lineColor: "green",
    },
    {
      STitle: "Next.js",
      percentage: "70%",
      BgColor: "gray",
      lineColor: "magenta",
    },
    {
      STitle: "Bootstrap",
      percentage: "90%",
      BgColor: "gray",
      lineColor: "orange",
    },
    {
      STitle: "Tailwind CSS",
      percentage: "85%",
      BgColor: "gray",
      lineColor: "goldenrod",
    },
  ];
  return (
    <section className="skills_area">
      <div className="container">
        <div className="about_title">
          <h2>My Skills</h2>
        </div>
        <div className="mySkills" ref={SkillArea}>
          <div className="skillBoxes">
            {Skills.map((skillInfos) => (
              <div className="progressbox" key={skillInfos.STitle}>
                <h4 className="progressTitle">{skillInfos.STitle}</h4>
                <div
                  className="progressLine"
                  style={{ background: skillInfos.BgColor }}
                >
                  <div
                    className="percent"
                    style={{
                      width: skillInfos.percentage,
                      background: skillInfos.lineColor,
                    }}
                  >
                    <p>{skillInfos.percentage}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillArea;
